import Autorenew from '@mui/icons-material/Autorenew';
import {Box} from '@mui/material';
import React, {memo} from 'react';

const Loader = ({size = '3xl'}) => {
  return (
    <Box display="flex" justifyContent="center" m={4}>
      <Autorenew className={`animate-spin text-${size}`} />
    </Box>
  );
};

export default memo(Loader);
